<div class="modal-container" #container>
    <div class="modal-body bg-transparent modal-gallery" id="modal">

        <div class="gallery-container">
            <!-- <div class="main-carousel">
                <button type="button" class="btn btn-control prev" (click)="dir.isRTL() ? carousel.next() : carousel.prev()"><mat-icon>chevron_left</mat-icon></button>
                <button type="button" class="btn btn-control next" (click)="dir.isRTL() ? carousel.prev() : carousel.next()"><mat-icon>chevron_right</mat-icon></button>
                <div class="product-gallery__featured">
                    <owl-carousel-o [options]="carouselOptions" #carousel id="modalCarousel">
                      <ng-container *ngFor="let image of items">
                        <ng-template carouselSlide [id]="image.image" [width]="666">
                            <div class="pproduct-image__body ">
                                <img [src]="image.image" class="pproduct-image__img">
                            </div>
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                </div>
            </div> -->
            <div class="flex flex-row items-center">
                <button type="button" class="btn btn-control prev" (click)="dir.isRTL() ? carousel.next() : carousel.prev()"><mat-icon>chevron_left</mat-icon></button>
                <button type="button" class="btn btn-control next" (click)="dir.isRTL() ? carousel.prev() : carousel.next()"><mat-icon>chevron_right</mat-icon></button>

                <!-- <owl-carousel-o [options]="carouselOptions" appOwlPreventClick #carousel>
                    <ng-template *ngFor="let image of items" carouselSlide [width]="600">
                        <div class="pproduct-image">
                            <img [src]="image.image" class="pproduct-image__img">
                        </div>
                    </ng-template>
                </owl-carousel-o> -->
                <div class="product-gallery__featuredd h-64 w-64 block">
                    <owl-carousel-o [options]="{items: 1, dots:true, margin:8, autoWidth: false}" #carousel id="modalCarousel" class="">
                      <ng-container *ngFor="let image of items">
                        <ng-template carouselSlide [id]="image.image">

                                <img [src]="image.image" class="product-image__img">
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                </div>
            </div>

            <!-- <div class="product-gallery__featured">
                <owl-carousel-o [options]="{items: 1, dots:true, margin:8, autoWidth: false}" #owlCar id="modalCarousel">
                  <ng-container *ngFor="let image of items">
                    <ng-template carouselSlide [id]="image.image">
                        <div class="pproduct-image__body ">
                            <img [src]="image.image" class="pproduct-image__img">
                        </div>
                    </ng-template>
                  </ng-container>
                </owl-carousel-o>
            </div> -->

            <!-- <div class="w-full flex flex-row justify-center">
                <button type="button" class="btn btn-control prev" (click)="prevImage(thumbCarousel)"><mat-icon>{{dir.isRTL()?'chevron_right':'chevron_left'}}</mat-icon></button>
                <div class="w-full"><img class="w-full object-contain" [src]="selectedImage"></div>
                <button type="button" class="btn btn-control next" (click)="nextImage(thumbCarousel)"><mat-icon>{{dir.isRTL()?'chevron_left':'chevron_right'}}</mat-icon></button>
            </div> -->

            <div class="thumbs-container">
                <ng-container *ngFor="let image of items; let i = index">
                        <a (click)=" changeimage(image.image, i)" class="thumb-body">
                            <div class="thumb">
                            <img [src]="image.image" class=""
                                [ngClass]="{'product-gallery__carousel-item--active':selectedImage === image.image || (i == 0 && !selectedImage)}">
                        </div></a>
                </ng-container>
            </div>

            <!-- <div class="product-gallery__carousel">
                <owl-carousel-o (changed)="changed(thumbCarousel)"
                    [options]="{items:3, dots:false, margin:5, autoWidth: true, center: true, loop: true}"
                    #thumbCarousel>
                    <ng-container *ngFor="let image of items; let i = index">
                        <ng-template carouselSlide [id]="image.image" [width]="88">
                            <a (click)=" changeimage(image.image, i)" class="product-image__body {{imageRatio}}">
                                <img [src]="image.image" class="product-image__img "
                                    [ngClass]="{'product-gallery__carousel-item--active':selectedImage === image.image || (i == 0 && !selectedImage)}">
                            </a>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div> -->
        </div>
    </div>
</div>
